import BaseService from "./BaseService";

export default class MensalidadesService extends BaseService {

  constructor(self) {
    super(self);
  }

  ListarMensalidadesAlunoAtivas(parameters) {
    return this.ExecutaFetch("/api/Mensalidades/ListarMensalidadesAlunoAtivas", "POST", parameters);
  }

  ListarMensalidadesAlunoCanceladas(parameters) {
    return this.ExecutaFetch("/api/Mensalidades/ListarMensalidadesAlunoCanceladas", "POST", parameters);
  }

  ListarValorBruto(parameters) {
    return this.ExecutaFetch("/api/Mensalidades/ListarValorBruto", "POST", parameters);
    }

    ListarCashback(alucod, espcod) {
        return this.ExecutaFetch("/api/Mensalidades/Cashback/" + alucod + '/' + espcod, "GET");
    }

  Gerar(parameters) {
    return this.ExecutaFetch("/api/Mensalidades/Gerar", "POST", parameters);
  }
}